import {
  Alert,
  Box,
  Card,
  ContentBlock,
  Page,
  PageBlock,
  Text,
} from 'braid-design-system';
import { Footer } from '#src/components/Footer/Footer.tsx';
import { AccountSetupForm } from './components/AccountSetupForm.tsx';
import { useState } from 'react';
import { AccountSetupSuccess } from './components/AccountSetupSuccess.tsx';
import { safeJwtDecode } from './components/jwt.ts';
import { useSearchParams } from 'react-router';
import * as z from 'zod';
export const ACCOUNT_SETUP_PATH = '/account-setup';

export const DecodedToken = z.object({
  jti: z.string(),
  exp: z.number(),
  iat: z.number(),
  organizationId: z.string(),
  invitationId: z.string(),
});
export type DecodedToken = z.infer<typeof DecodedToken>;

const PageBase = ({ children }: { children: React.ReactNode }) => (
  <Page footer={<Footer paddingX="large" />}>
    <PageBlock width="large">
      <Box paddingY="xxxlarge">{children}</Box>
    </PageBlock>
  </Page>
);

export const AccountSetupPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [success, setSuccess] = useState(false);
  const decoded = safeJwtDecode(token, DecodedToken);

  if (!token || decoded.success === false) {
    return (
      <PageBase>
        <Alert tone="critical">
          <Text>
            Invalid token. Please check your email for the correct link.
          </Text>
        </Alert>
      </PageBase>
    );
  }

  const payload = decoded.value;
  if (payload.exp * 1000 < Date.now()) {
    return (
      <PageBase>
        <Alert tone="critical">
          <Text>
            Invitation expired. Please request for your account admin to send
            you a new invite.
          </Text>
        </Alert>
      </PageBase>
    );
  }
  return (
    <PageBase>
      <ContentBlock width="small">
        <Card>
          {success ? (
            <AccountSetupSuccess organizationId={payload.organizationId} />
          ) : (
            <AccountSetupForm setSuccess={setSuccess} token={token} />
          )}
        </Card>
      </ContentBlock>
    </PageBase>
  );
};
